import { Switch } from "@/components/ui/switch";
import { useState, useEffect } from "react";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useSelector } from "react-redux";
import CreateBrandDialog from "@/components/dialog/menu-manage/common-dialog/create-brand";
import CreateCategoryDialog from "@/components/dialog/menu-manage/common-dialog/create-category";
import { ButtonType } from "@/components/lib/Button";

function Step1({ form, dessert_id }) {
  const { categories } = useSelector((state) => state.essentialMenu.categories);
  const { brands } = useSelector((state) => state.essentialMenu.brands);
  const [isBrandDialog, setIsBrandDialog] = useState(false);
  const [isCtgDialog, setIsCtgDialog] = useState(false);
  const [showItem, setShowItem] = useState(false);
  const [showBrand, setShowBrand] = useState(false);
  const itemNo = form.watch("item_no");
  const brand = form.watch("brand_id");

  useEffect(() => {
 setShowItem(itemNo && itemNo !== null);
    setShowBrand(!!brand);
  }, [itemNo, brand]);

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {form.watch("type") == "update"
            ? "Update Dessert"
            : "Add New Dessert         "}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-8">
          <div className="">
            <div className="flex gap-2 items-center">
              <Switch
                checked={showItem}
                onCheckedChange={(val) => {
                  setShowItem(val);
                    if (!val) {
                    form.setValue("item_no", null);
                  }
                }}
              />
              <Label>Item No</Label>
            </div>
            {showItem && (
              <div className="mt-3">
              <FormInputField
                name="item_no"
                style="bg-cblack7"
                placeholder={"Enter item no (must be number)"}
                form={form}
                type="text"
              />
              </div>
            )}
          </div>
          <FormInputField
            name="name"
            style="bg-cblack7"
            placeholder={"Enter Name"}
            form={form}
            type="text"
            label={"Name"}
          />
          <FormInputField
            name="description"
            style="bg-cblack7"
            placeholder={"Enter description"}
            form={form}
            type="text"
            label={"Description"}
          />
          <div className="flex items-end gap-4">
            <FormInputField
              name="category_id"
              style="bg-cblack7 flex-1"
              placeholder={"Category"}
              form={form}
              type="select"
              parseAs="number"
              selectOption={
                categories && categories.length > 0
                  ? categories
                      .filter((cat) => cat.status === "active")
                      .map((cat) => ({
                        label: cat.name,
                        value: cat.id,
                      }))
                  : [
                      {
                        label: "No category available",
                        value: "",
                        disabled: true,
                      },
                    ]
              }
              label={"Category"}
            />
            <ButtonType onClick={() => setIsCtgDialog(true)}>
              Add New Category
            </ButtonType>
            <CreateCategoryDialog
              title={"Create New Category"}
              menu_id={dessert_id}
              onClose={() => setIsCtgDialog(false)}
              isOpen={isCtgDialog}
            />
          </div>

          <div className="flex  justify-between gap-5 items-end">
            <div className="flex items- flex-col w-full">
              <div className="flex items-center gap-2 mb-3">
                <Switch
                  checked={showBrand}
                  onCheckedChange={(val) => {
                    setShowBrand(val);
                    form.setValue("brand_id", null)
                  }}
                />
                <Label>Brand</Label>
              </div>
              <div className="flex items-end jub gap-4 w-full">
                {showBrand && (
                  <FormInputField
                    name="brand_id"
                    style="bg-cblack7 flex-1"
                    placeholder={"Brand"}
                    form={form}
                    type="select"
                    parseAs="number"
                    selectOption={
                      brands && brands?.length > 0
                        ? brands
                          .filter((item) => item?.status === "active")
                          .map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))
                        : [
                            {
                              label: "No brand available",
                              value: "",
                              disabled: true,
                            },
                          ]
                    }
                  />
                )}
              </div>
            </div>
            {showBrand && (
              <Button
                onClick={() => setIsBrandDialog(true)}
                type="button"
                className="bg-cgreen/50 text-cwhite w-full md:w-[25%]"
              >
                Create New Brand
              </Button>
            )}
            <CreateBrandDialog
              title={"Create New Brand"}
              menu_id={dessert_id}
              onClose={() => setIsBrandDialog(false)}
              isOpen={isBrandDialog}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default Step1;
